<template>
	<div class="new-store-welcome-container">
		<h2 class="title is-size-4">What's new?</h2>
		<hr>
		<p class="new-features-message">
			<ul>
				<li class="feature is-size-5">Securely save your payment information for a fast and convenient checkout!</li>
				<li class="feature is-size-5">Earn loyalty rewards when you order online or in-store!</li>
			</ul>
		</p>
		<hr>
		<BaseButton
			:classNames="['button--modifier', 'input-field-button']"
			title="Login/Sign-up"
			type="fill"
			@click="showLogin"/>
		<hr>
		<a class="tp-link" :href="getFAQLink" target="_blank">Frequently Asked Questions</a>
	</div>
</template>

<script>
	import Login from '@/components/auth/Login.vue';
	import welcomeMixin from '@Mixin/welcomeMixin';
	import modalMixin from '@Mixin/modalMixin';
	export default {
		mixins: [
			modalMixin,
			welcomeMixin,
		],
		computed: {
			getFAQLink() {
				const $appConstants = this.$appConstants;
				const link = $appConstants.links.FAQ;
				return link;
			},
		},
		methods: {
			showLogin() {
				this.$modal.hide('contentModal');
				this.triggerModal({
					component: Login,
					title: "Login",
					classes: 'global-modal',
					modalName: "loginModal",
					contentProperties: {
						routeTo: '/',
						skipToPin: false,
					},
				});
			},
		},
		mounted() {
			this.welcome_setShowNewStore(false);
		}
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.new-store-welcome-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		padding-top: 2em;
		.title {
			text-shadow: 1px 1px 2px $greyOutline;
			margin-bottom: 0;
		}
		.new-features-message {
			padding-bottom: 1em;
			.feature {
				list-style-type: disc;
				color: $navigationItemColor;
				text-shadow: 1px 1px 2px $greyOutline;
			}
		}
	}
	@include mobile {
		.new-store-welcome-container {
			padding-top: 4em;
			.new-features-message {
				max-width: 80vw;
			}
		}
	}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/landing/NewStoreWelcome.vue